<template>
  <div class="contentBody">
    <div class="contentBody__title">
      <span class="text">登録確認</span>
    </div>
    <div class="contentBody__section" v-if="isLoggedIn">
      <form
      method="post"
      :action="action"
      ref="form"
      @submit.prevent="handleSubmit">

      <input type="hidden" name="cpno" :value="cpno">
      <input type="hidden" name="_token" :value="token">

      <form-input
      name="nickname"
      v-model="nickname"
      type="text"
      :label="self.nickname.label"
      :placeholder="self.nickname.placeholder"
      :validation="{ rules: {
        required: true,
        max: 15
        } }"
      ></form-input>

      <form-label label="メールアドレス" :register="true"></form-label>
      <p class="u-mg-0 u-mg-b-2 u-tx-black">
        {{ email || '未設定' }}
      </p>

      <hr class="contentSeparatorSection">

      <div class="formGroup__subText u-mg-t-2">
        ※携帯メールアドレスをお使いの場合<br>
        ドメイン設定の影響で登録メールが届かない場合がありますので、事前に「uranai.tv」を受信設定することをオススメしております。
      </div>

      <div class="u-mg-t-6 u-mg-b-4">
        <label class="confirmTerms  u-mb-t-2">
          <input type="checkbox"
          class="confirmTerms__checkbox"
          name="terms"
          value="1"
          required
          v-validate="'required'"
          >
          <span class="confirmTerms__label"><a href="https://agaru.tv/terms-of-service/" target="_new">利用規約</a>と<a href="https://agaru.tv/privacy/" target="_new">プライバシーポリシー</a>に同意する</span>
        </label>
        <p v-show="errors.has('terms')" class="formGroup__errorMessage">利用規約へ同意して頂く必要があります。</p>
      </div>

      <div class="contentFooter">
        <button type="submit" class="btn"
          data-color="brand"
          data-block="true"
        >入力した内容を確認</button>
      </div>

    </form>
  </div>
</div>
</template>

<script>
import firebaselogin from './firebaselogin'
import { FORM_DATA } from '@/CONSTS'

export default {
  name: 'sns-register',
  inject: ['$validator'],
  mixins: [firebaselogin],
  props: {
    registToken: String,
    email: String
  },
  data() {
    return {
      cpno: window.Laravel.cpno,
      token: window.Laravel.csrfToken,
      nickname: '',
      self: FORM_DATA.self
    }
  },
  methods: {
    handleSubmit() {
      this.$validator.validateAll().then(res => {
        if (!res) {
          return false
        } else {
          this.$refs.form.submit()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/SnsregistForm.vue